// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as DisclosuresRouteImport } from './routes/disclosures'
import { Route as DallasRouteImport } from './routes/dallas'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ApplyFundingRouteImport } from './routes/apply-funding'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServiceAreasIndexRouteImport } from './routes/service-areas.index'
import { Route as ServiceAreasSlugRouteImport } from './routes/service-areas.$slug'
import { Route as DallasIndexRouteImport } from './routes/dallas.index'
import { Route as DallasSlugRouteImport } from './routes/dallas.$slug'
import { Route as DallasSlugIndexRouteImport } from './routes/dallas.$slug.index'
import { Route as DallasSlugProductRouteImport } from './routes/dallas.$slug.$product'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const DisclosuresRoute = DisclosuresRouteImport.update({
            id: '/disclosures',path: '/disclosures',getParentRoute: () => rootRouteImport
          })
const DallasRoute = DallasRouteImport.update({
            id: '/dallas',path: '/dallas',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ApplyFundingRoute = ApplyFundingRouteImport.update({
            id: '/apply-funding',path: '/apply-funding',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServiceAreasIndexRoute = ServiceAreasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServiceAreasRoute
          })
const ServiceAreasSlugRoute = ServiceAreasSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServiceAreasRoute
          })
const DallasIndexRoute = DallasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DallasRoute
          })
const DallasSlugRoute = DallasSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => DallasRoute
          })
const DallasSlugIndexRoute = DallasSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DallasSlugRoute
          })
const DallasSlugProductRoute = DallasSlugProductRouteImport.update({
            id: '/$product',path: '/$product',getParentRoute: () => DallasSlugRoute
          })





const DallasSlugRouteChildren = {
  DallasSlugProductRoute: DallasSlugProductRoute,DallasSlugIndexRoute: DallasSlugIndexRoute
}

const DallasSlugRouteWithChildren = DallasSlugRoute._addFileChildren(DallasSlugRouteChildren)



const DallasRouteChildren = {
  DallasSlugRoute: DallasSlugRouteWithChildren,DallasIndexRoute: DallasIndexRoute
}

const DallasRouteWithChildren = DallasRoute._addFileChildren(DallasRouteChildren)




const ServiceAreasRouteChildren = {
  ServiceAreasSlugRoute: ServiceAreasSlugRoute,ServiceAreasIndexRoute: ServiceAreasIndexRoute
}

const ServiceAreasRouteWithChildren = ServiceAreasRoute._addFileChildren(ServiceAreasRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ApplyFundingRoute: ApplyFundingRoute,ContactRoute: ContactRoute,DallasRoute: DallasRouteWithChildren,DisclosuresRoute: DisclosuresRoute,PrivacyRoute: PrivacyRoute,ServiceAreasRoute: ServiceAreasRouteWithChildren,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)